(function () {
    // Theme toggle handling
    function initTheme() {
        var toggleBtns = document.querySelectorAll('.js-theme-toggle');
        if (!toggleBtns.length) return;

        function updateAria(theme) {
            toggleBtns.forEach(function (btn) {
                btn.setAttribute('aria-label', theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme');
            });
        }

        var currentTheme = document.documentElement.getAttribute('data-theme') ||
            (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
        updateAria(currentTheme);

        toggleBtns.forEach(function (btn) {
            btn.addEventListener('click', function () {
                var isDark = document.documentElement.getAttribute('data-theme') === 'dark' ||
                    (!document.documentElement.getAttribute('data-theme') && window.matchMedia('(prefers-color-scheme: dark)').matches);
                var nextTheme = isDark ? 'light' : 'dark';

                document.documentElement.setAttribute('data-theme', nextTheme);
                try {
                    localStorage.setItem('theme', nextTheme);
                } catch (_) {}
                updateAria(nextTheme);
            });
        });
    }

    // Code copy buttons
    function initCopyButtons() {
        var blocks = document.querySelectorAll('.prose-article pre');
        blocks.forEach(function (pre) {
            if (pre.querySelector('.code-copy-btn')) return;
            var wrapper = document.createElement('div');
            wrapper.className = 'code-block-wrapper relative group';
            pre.parentNode.insertBefore(wrapper, pre);
            wrapper.appendChild(pre);

            var btn = document.createElement('button');
            btn.className = 'code-copy-btn absolute top-3 right-3 px-2 py-1 text-xs font-mono rounded bg-surface border border-border text-subtle opacity-0 group-hover:opacity-100 transition-opacity';
            btn.type = 'button';
            btn.innerText = 'Copy';
            btn.addEventListener('click', function () {
                var code = pre.querySelector('code') || pre;
                navigator.clipboard.writeText(code.innerText).then(function () {
                    btn.innerText = 'Copied!';
                    setTimeout(function () {
                        btn.innerText = 'Copy';
                    }, 2000);
                });
            });
            wrapper.appendChild(btn);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initTheme();
            initCopyButtons();
        });
    } else {
        initTheme();
        initCopyButtons();
    }
})();
